import React from "react";
import { NavLink, useHistory } from "react-router-dom";
import "./navigation.styles.scss";

interface IProps {
    sideDrawerHandler: (status: boolean) => void;
    menus: {
        link: string;
        logo: string;
        name: string;
    }[];
}

const NavigationContainer = ({ sideDrawerHandler, menus }: IProps) => {
    const handleClick = (index: number) => {
        if (sideDrawerHandler) sideDrawerHandler(false);
    };
    const history = useHistory();

    return (
        <nav className="container">
            {menus.map((menu, index) => {
                return (
                    <NavLink
                        exact
                        to={menu.link}
                        onClick={() => handleClick(index)}
                        key={index}
                        activeClassName="active"
                        className={`navigation-item ${
                            history.location.pathname.includes(menu.link)
                                ? "active"
                                : ""
                        }`}
                    >
                        <i className="material-icons">{menu.logo}</i>
                        <span>{menu.name}</span>
                    </NavLink>
                );
            })}
        </nav>
    );
};

export default NavigationContainer;
